<template>
  <div class="news-mb">
    <div class="news-mb__header">
      <div class="news-mb__header--category">
        <ListCategory
          v-if="isCategoryPage"
          class="mobile"
          :post-category-alias="postCategoryAliasComputed"
          :list-category="categoryListData || []"
          @change-category="onChangeCategory"
        />
      </div>
      <slot name="header" />
    </div>
    <div class="news-mb__content">
      <NuxtPage />
    </div>
    <SeoContent />
  </div>
</template>
<script setup lang="ts">
import NewIndex from '~/components/mobile/pages/news/index.vue'
import NewCategory from '~/components/mobile/pages/news/category.vue'
import { useCategories } from '~~/composables/news/useCategories'
import ListCategory from '~/components/mobile/pages/news/list-category.vue'
import { PAGE_URLS } from '~/config/page-url'
import SeoContent from '~~/components/common/seo-content.vue'

const route = useRoute()

const { getCategories, categoryList, onChangeCategory, postCategoryAlias } = useCategories()

const isCategoryPage = computed(() => {
  return route.path === PAGE_URLS.NEWS || route.path.includes(PAGE_URLS.NEWS_CATEGORY)
})

const postCategoryAliasComputed = computed(() => {
  return route.params.Slug as string || 'all'
})

const { data: categoryListData } = await useAsyncData(async () => {
  await getCategories()
  return categoryList.value || []
})
</script>
<style scoped src="public/assets/scss/components/mobile/layouts/news/index.scss" />
